import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Teleport from "./Teleport";
import MobileOtpNoAccDialog from "./MobileOtpNoAccDialog";
import MobileOtpMethodSelectionDialog from "./MobileOtpMethodSelectionDialog";
import MobileOtpToast from "./MobileOtpToast";
import * as verificationActions from "../../../actions/verification";
import { trans } from "../../../localization/language";
import countries from "./countries.json";

const countriesByPCode = {};
for (const country of countries) {
  countriesByPCode[country.pcode] = country;
}

class MobileOtpInputField extends React.Component {
  static defaultProps = {
    template_params: null,
    mobile_code: null,
    mobile_no: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      opened: "",
      gatewaySelected: this.props.gatewayOptions[0],
    };
    this.changeGateway(this.props.gatewayOptions[0]);
  }

  changeGateway = (gateway) => {
    const { onChangeGateway } = this.props;
    onChangeGateway && onChangeGateway(gateway);
  }

  getMobileOtpAlt = (gatewaySelected) => {
    this.setState({ gatewaySelected });
    this.changeGateway(gatewaySelected);
    this.closePopup();
  };

  handleChangeCode = (e) => {
    const { onChange } = this.props;
    onChange && onChange(e);
  }

  handleGetCode = () => {
    let mobileNo = null;
    if (this.props.mobile_code && this.props.mobile_no) {
      mobileNo = this.props.mobile_code + this.props.mobile_no
    }
    this.props.getCode(
      mobileNo,
      null,
      null,
      this.props.template_id,
      this.props.template_params,
      this.state.gatewaySelected,
    );
  };

  openSelectionPopup = () => {
    this.setState({ opened: "selection" });
  };

  closePopup = () => {
    this.setState({ opened: "" });
    this.props.setError();
  };

  render() {
    const gatewayOptionsAlt = this.props.gatewayOptions.filter(
      (gateway) => gateway !== this.state.gatewaySelected
    );

    let dialog;
    if (this.state.opened === "selection") {
      dialog = (
        <MobileOtpMethodSelectionDialog
          options={gatewayOptionsAlt}
          onClose={this.closePopup}
          onConfirm={this.getMobileOtpAlt}
        />
      );
    } else if (this.props.err === "no_acc") {
      dialog = (
        <MobileOtpNoAccDialog
          gateway={this.state.gatewaySelected}
          options={gatewayOptionsAlt}
          onClose={this.closePopup}
          onSwitch={this.openSelectionPopup}
          onConfirm={this.getMobileOtpAlt}
        />
      );
    }

    let req_method;
    if (gatewayOptionsAlt.length > 1) {
      req_method = (
        <strong onClick={this.openSelectionPopup}>
          {trans("register_link_mobile_req_method_alt")}
        </strong>
      );
    } else if (gatewayOptionsAlt.length === 1) {
      req_method = (
        <strong onClick={() => this.getMobileOtpAlt(gatewayOptionsAlt[0])}>
          {trans("register_link_mobile_req_method", {
            gateway: trans(gatewayOptionsAlt[0]),
          })}
        </strong>
      );
    }

    let placeholder;
    if (this.state.gatewaySelected) {
      placeholder = trans("register_link_mobile_gateway_code", {
        gateway: trans(this.state.gatewaySelected),
      });
    } else {
      placeholder = trans("verify_code_placeholder");
    }

    let toast;
    if (this.props.toast) {
      toast = (
        <MobileOtpToast
          delay={3000}
          message={trans("register_link_mobile_sent", {
            gateway: trans(this.props.toast),
          })}
          onClose={this.props.setToast}
        />
      );
    }

    return (
      <div
        className={`content__form-otpcode content__form-otpcode--col ${
          this.props.loading ? "loading" : ""
        }`}
      >
        <div className="content__form-otpcode--flex">
          <div className="content__form-input">
            <input
              type="tel"
              maxLength="6"
              className="content__form-input-widget J-validated-field"
              placeholder={placeholder}
              value={this.props.value}
              onChange={this.handleChangeCode}
            ></input>
          </div>
          {this.props.loading && (
            <button
              type="button"
              className="content__form-getotp content__form-getotp--disabled loading"
            >
              {trans("register_link_mobile_loading")}
            </button>
          )}
          <button
            id="J-getotp-trigger"
            type="button"
            className={`content__form-getotp`}
          >
            <span
              className="content__form-getotp-before"
              onClick={this.handleGetCode}
            >
              {trans("get_otp_btn")}
            </span>
            <span className="content__form-getotp-after">
              {trans("wait")} <span id="J-getotp-cd"></span>s
            </span>
          </button>
        </div>

        <div id="J-getotp-hint">
          {this.props.sentCount > 0 && gatewayOptionsAlt.length > 0 && (
            <React.Fragment>
              <div className="content__form-getotp-hint-before">
                {trans("register_link_mobile_hint", { req_method })}
              </div>
              <div className="content__form-getotp-hint-after">
                {trans("register_link_mobile_hint_cd", { req_method })}
              </div>
            </React.Fragment>
          )}
        </div>

        <Teleport>
          {dialog}
          {toast}
        </Teleport>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { userInfo } = state.data;
  const mobileCountry = countriesByPCode[ownProps.mobile_code || userInfo.country_code];

  let gatewayOptions = [];
  if (mobileCountry) {
    const key = `region_${mobileCountry.code.toLowerCase()}`;
    if (userInfo.send_otp_methods && userInfo.send_otp_methods[key]) {
      gatewayOptions = userInfo.send_otp_methods[key].options || [];
    }
  }

  return {
    gatewayOptions,
    err: state.verification.err,
    loading: state.verification.loading,
    sentCount: state.verification.sent_count || 0,
    toast: state.verification.toast,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, verificationActions), dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileOtpInputField);



// WEBPACK FOOTER //
// ./app/components/security/verification/MobileOtpInputField.js